export default "__VITE_ASSET__CMUnASJl__"